$('[data-captcha-refresh]').click((event) => {
  event.preventDefault();
  $.getJSON($(event.currentTarget).data('captcha-refresh'), {}, (result) => {
    $('.captcha').attr('src', result.image_url);
    $('#id_captcha_0').val(result.key);
  });
  return false;
});
